import request from "@/utils/request";
export function uploads(data) {
  return request({
    url: "/api/api/file/uploads",
    method: "post",
    data,
  });
}
